var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-500q-62 0-106-44t-44-106q0-63 44-106.5T440-800q63 0 106.5 43.5T590-650q0 62-43.5 106T440-500zM898-20L758-160q-23 17-47.5 23.5T660-130q-71 0-120.5-49.5T490-300q0-71 49.5-120.5T660-470q71 0 120.5 49.5T830-300q0 26-6.5 50.5T800-202L940-62l-42 42zM660-190q47 0 78.5-31.5T770-300q0-47-31.5-78.5T660-410q-47 0-78.5 31.5T550-300q0 47 31.5 78.5T660-190zM464-419q-38 60-33.5 132T478-160H120v-94q0-37 17.5-63t50.5-43q47-23 122.5-43.5T464-419z"
  })));
}
export default SvgExpertsActive;